import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

interface ConfigFormContextValue {
    isEditMode: boolean;
}

const ConfigFormContext = createContext<ConfigFormContextValue>({
    isEditMode: false,
});

export const useConfigFormContext = () => useContext(ConfigFormContext);

interface ConfigFormProviderProps {
    children: ReactNode;
    isEditMode?: boolean;
}

export function ConfigFormProvider({ children, isEditMode = false }: ConfigFormProviderProps) {
    return <ConfigFormContext.Provider value={{ isEditMode }}>{children}</ConfigFormContext.Provider>;
}
